<template>
  <div class="layout">
    <el-container style="height: 100vh">
      <!-- 侧边栏 -->
      <el-aside width="165px" style="background-color: var(--theme-color); color: #fff;height:100vh;" class="flex flex-column justify-content-between">
        <div>
          <div style="padding: 50px 20px; font-size: 18px; color: rgb(0 81 106);" class="text-center">AI数智全擎</div>
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            text-color="#000000"
            active-text-color=" var(--theme-text-color)"
            router
          >
            <el-menu-item index="/">
              <i class="el-icon-document-checked"></i>
              <span>文字校对</span>
            </el-menu-item>
            <!-- <el-menu-item index="/word">
              <i class="el-icon-document"></i>
              <span>文档校对</span>
            </el-menu-item> -->
            <el-menu-item index="/writing">
              <i class="el-icon-edit"></i>
              <span>AI写作</span>
            </el-menu-item>
            <el-menu-item index="/imagecheck">
              <i class="el-icon-picture-outline"></i>
              <span>图片审查</span>
            </el-menu-item>
            <el-menu-item index="/videocheck">
              <i class="el-icon-video-camera"></i>
              <span>视频审查</span>
            </el-menu-item>
            <el-menu-item index="/image">
              <i class="el-icon-picture-outline-round"></i>
              <span>图像生成</span>
            </el-menu-item>
            <el-menu-item index="/video">
              <i class="el-icon-video-play"></i>
              <span>视频生成</span>
            </el-menu-item>
            <el-menu-item index="/media">
              <i class="el-icon-edit-outline"></i>
              <span>媒体发文</span>
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 底部登录按钮 -->
        <div style="padding: 100px 20px; text-align: center;">
          <div v-if="isLoggedIn" class="sidebar-user">
            <div class="sidebar-user-name">{{ displayName }}</div>
            <el-button
              type="primary"
              size="medium"
              round
              icon="el-icon-user-solid"
              style="background-color: #000000;border:none;"
              @click="toUserCenter"
            >
              个人中心
            </el-button>
          </div>
          <el-button
            type="primary"
            size="medium"
            round
            icon="el-icon-user-solid"
            style="background-color: #000000;border:none;"
            @click="toLogin"
            v-else
          >
            登录/注册
          </el-button>
        </div>
      </el-aside>

      <!-- 主体内容 -->
      <el-container>
        <!-- <el-header class="headers">
          
        </el-header> -->
        <el-main style="padding:0;">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>


export default {
  name: 'Layout',
  computed: {
    // 从 Vuex 获取用户信息
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLoggedIn() {
      return !!(this.$store.state.userInfo || localStorage.getItem('token'))
    },
    displayName() {
      const user = this.userInfo || this.getLocalUserInfo()
      return user.company || user.nickname || '用户'
    }
  },
  methods: {
    getLocalUserInfo() {
      try {
        return JSON.parse(localStorage.getItem('userInfo')) || {}
      } catch (e) {
        return {}
      }
    },
    toUserCenter(){
      if (this.$route.path !== '/usercenter') {
        this.$router.push('/usercenter')
      }
    },
    toLogin() {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.$store.commit('clearUserInfo')
      if (this.$route.path !== '/login') {
        this.$router.push('/login').catch(err => {
          if (err && err.name !== 'NavigationDuplicated' && err.name !== 'NavigationRedirected') {
            console.error(err)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
:root {
  --theme-color: #E6EDFF;
  --theme-text-color: rgb(0 81 106);
}

.layout {
  height: 100vh;
}

.el-menu-item {
  background-color: var(--theme-color) !important;
}
.el-menu-item:hover {
  background-color: rgb(167, 227, 255) !important;
}
.headers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--theme-color);
}

.sidebar-user {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.sidebar-user-name {
  max-width: 125px;
  color: #303133;
  font-size: 13px;
  line-height: 1.4;
  word-break: break-all;
}
</style>
